import { getApplicantHandoffView } from '@findigs/api/index.server';
import { invariantServer } from '@findigs/helpers/src/helpers/invariant.server';
import { validateDjangoUUID } from '@findigs/helpers/src/helpers/validate/django-uuid';
import { json } from '@remix-run/node';
import type { MetaFunction } from '@remix-run/node';
import { useLoaderData, useSearchParams } from '@remix-run/react';
import { HandoffLanding } from '~/components/handoff-landing';
import { getHeadersToUnsetJWTSession } from '~/sessions/session-new.token.shim';
import type { RemixLoader } from '~/types';

export const meta: MetaFunction = () => {
  return [{ title: 'Handoff | Findigs' }];
};

export const handle: RouteHandle = {
  navbar: false,
  footer: false,
};

export const loader = async function ({ request, params }) {
  const { unit_id } = params;

  invariantServer(validateDjangoUUID(unit_id), 404, 'invalid django uuid');

  const { result } = await getApplicantHandoffView({ unit_id });

  invariantServer(result, 404, 'getApplicantHandoffView() returned null');

  return json(result, {
    headers: await getHeadersToUnsetJWTSession(request),
  });
} satisfies RemixLoader;

export default function HandoffScreen() {
  const data = useLoaderData<typeof loader>();
  const [searchParams] = useSearchParams();
  return <HandoffLanding {...{ ...data, searchParams: searchParams }} />;
}
